import { useTheme } from "@/components/context/ThemeContext"
import styles from "./delete-confirm-modal.module.css"

export default function DeleteConfirmModal({ tournament, onClose, onConfirm }) {
  const {theme} = useTheme()
  return (
    <div className={`${styles.modalOverlay} ${theme==="light" ? "light" : ""}`} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.iconContainer}>
          <span className={styles.warningIcon}>⚠</span>
        </div>

        <h2 className={styles.title}>Delete Tournament?</h2>

        <p className={styles.message}>
          You are about to permanently delete <strong>{tournament.name}</strong>. This action cannot be undone.
        </p>

        <div className={styles.details}>
          <p>
            <strong>Tournament:</strong> {tournament.name}
          </p>
          <p>
            <strong>Game:</strong> {tournament.game}
          </p>
          <p>
            <strong>Current Registrations:</strong> {tournament.currentRegistrations}
          </p>
        </div>

        <p className={styles.warning}>All associated data will be permanently removed.</p>

        <div className={styles.formButtons}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.deleteButton} onClick={onConfirm}>
            Delete Tournament
          </button>
        </div>
      </div>
    </div>
  )
}
